import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

@Component({
    template: '',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule]
})
export class AbstractInputComponent {
    @Input()
    control: AbstractControl;
    @Input()
    placeholder?: string;
    @Input()
    label?: string;
    @Input()
    marginBottom?: 'default' | 'small' | 'none' = 'default';
    @Input()
    disabled?: boolean;
    @Input()
    maxlength?: number;

    @Input()
    clearButton?: boolean;

    @Output()
    inputBlur = new EventEmitter();

    @Output()
    inputFocus = new EventEmitter();

    public get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }
}
